import { FC } from 'react';
import { ModalProps } from 'antd/lib/modal';
import { Button, Modal } from 'antd';
import ProjectCreateForm, { ProjectCreateFormDataProps } from 'components/molecules/ProjectCreateForm';

interface Props extends ModalProps {
  translations: Record<string, string>;
  formData: ProjectCreateFormDataProps;
}

const ProjectCreateModal: FC<Props> = ({
  translations: modalTranslations,
  formData,
  onCancel,
  ...props
}) => {
  const { title, actionButton, cancelButton } = modalTranslations;
  const {
    form,
    translations,
    typeOptions,
    clientOptions,
    supportEmailsSeparators,
    allowedUsersToVerifyAccounts,
    onFinish,
    onFinishFailed,
    validateEmailFormat,
    onSelectClient,
    onChangeUserVerificationCheck,
    isClientSelectLoading,
    showClientOptions,
    loading,
    isLoadingUserVerifierList,
    isUsersRequireVerificationChecked,
  } = formData;

  return (
    <Modal
      {...props}
      title={title}
      onCancel={onCancel}
      footer={[
        <Button key={'back'} onClick={onCancel}>
          {cancelButton}
        </Button>,
        <Button key={'submit'} type={'primary'} loading={loading} onClick={() => form.submit()}>
          {actionButton}
        </Button>,
      ]}
      destroyOnClose
    >
      <ProjectCreateForm
        form={form}
        allowedUsersToVerifyAccounts={allowedUsersToVerifyAccounts}
        translations={translations}
        typeOptions={typeOptions}
        clientOptions={clientOptions}
        supportEmailsSeparators={supportEmailsSeparators}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        validateEmailFormat={validateEmailFormat}
        onSelectClient={onSelectClient}
        isClientSelectLoading={isClientSelectLoading}
        loading={loading}
        showClientOptions={showClientOptions}
        isLoadingUserVerifierList={isLoadingUserVerifierList}
        isUsersRequireVerificationChecked={isUsersRequireVerificationChecked}
        onChangeUserVerificationCheck={onChangeUserVerificationCheck}
      />
    </Modal>
  );
};

export default ProjectCreateModal;
